import React from 'react';
import { StickyAlertBar } from './components/StickyAlertBar';
import { HeroSection } from './components/HeroSection';
import { SalesLetter } from './components/SalesLetter';
import { WhatYouGet } from './components/WhatYouGet';
import { BonusSection } from './components/BonusSection';
import { PricingOffer } from './components/PricingOffer';
import { Guarantee } from './components/Guarantee';
import { SocialProof } from './components/SocialProof';
import { FAQ } from './components/FAQ';
import { FinalClose } from './components/FinalClose';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen w-full bg-cream" data-id="element-0">
      <StickyAlertBar data-id="element-1" />
      <HeroSection data-id="element-2" />
      <SalesLetter data-id="element-3" />
      <WhatYouGet data-id="element-4" />
      <BonusSection data-id="element-5" />
      <PricingOffer data-id="element-6" />
      <Guarantee data-id="element-7" />
      <SocialProof data-id="element-8" />
      <FAQ data-id="element-9" />
      <FinalClose data-id="element-10" />
      <Footer data-id="element-11" />
    </div>;
}